//
//
//
//
//
//
//
//
//
//
//
//

export default {
	data() {
		return {
			value: '',
			loading: false,
			iconShow: false,
			placeholder: '',
			status: '',
			email:'',
			memberName:'',
			idCard:''
		}
	},
	watch: {
		value(val, old) {
			if (val.length > 0) {
				this.iconShow = true
			} else {
				this.iconShow = false
			}
		}
	},
	onLoad(event) {
		this.status = event.status
		this.queryData()
		if (event.status === 'name') {
			uni.setNavigationBarTitle({
				title: '设置名称'
			})
			this.placeholder = '请输入您的名称'
		} else if (event.status === 'idCard') {
			uni.setNavigationBarTitle({
				title: '设置身份证'
			})
			this.placeholder = '请输入身份证号'
		} else {
			uni.setNavigationBarTitle({
				title: '设置邮箱'
			})
			this.placeholder = '请输入邮箱'
		}
	},
	methods: {
		inputValue(e) {
			this.value = e.target.value
		},
		//内容清空
		clearContent() {
			this.value = ''
		},
		//获取信息
		queryData() {
			this.$ajax({
				method: 'post',
				url: '/weChat/member/queryById',
				data: {
					memberId: this.$store.state.userInfo.memberId
				},
			}).then(res => {
				this.idCard = res.data.idCard
				this.email = res.data.email
				this.memberName = res.data.memberName
				this.value = this.status === 'name' ? res.data.memberName : this.status === 'idCard' ? res.data.idCard : res.data
					.email
			})
		},
		//更新
		update() {
			let index = 1
			index = this.status === 'name' ? 1 : this.status === 'idCard' ? 2 : 3
			if (this.test() || !this.value) {
				this.chooseType(this.value, index)
			} else {
				uni.showToast({
					title: this.status === 'name' ? '联系人不可包含特殊字符和数字' : this.status === 'idCard' ? '身份证格式不正确!' : '邮箱地址格式不正确!',
					icon: 'none'
				})
			}
		},
		chooseType(value, index) {
			this.loading = true
			this.$ajax({
				method: 'post',
				url: '/weChat/member/updateById',
				data: {
					memberId: this.$store.state.userInfo.memberId,
					memberName: index === 1 ? value : this.memberName,
					idCard: index === 2 ? value : this.idCard,
					email: index === 3 ? value : this.email
				}
			}).then(res => {
				this.loading = false
				uni.navigateBack({
					delta: 1
				})
			})
		},
		test() {
			if (this.status === 'name') {
				return /^[\u4E00-\u9FA5A-Za-z]+$/.test(this.value)
			} else if (this.status === 'idCard') {
				return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(this.value)
			} else {
				return /^[a-zA-Z\d]+([-_.][a-zA-Z\d]+)*@[a-zA-Z\d]+\.[a-zA-Z\d]{2,4}$/.test(this.value)
			}
		},
	}
}
